import React from "react";

const Group = ({
  formValues,
  item,
  mapChildren,
  onChange,
  ownKey,
  setFormValues,
  validationErrors,
  ctx,
  showQuestionId,
  showQuestionKey,
}) => {
  return (
    <div>
      {mapChildren({
        parentSchema: item,
        formValues,
        parentKey: ownKey,
        onChange,
        setFormValues,
        validationErrors,
        ctx,
        showQuestionId,
        showQuestionKey,
      })}
    </div>
  );
};

export default Group;
